module.exports = __webpack_public_path__ + "img/Course1.347c804a.png";